
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 9.928a1.929 1.929 0 100-3.857 1.929 1.929 0 000 3.857z"}}),_c('path',{attrs:{"d":"M12.757 9.929a1.06 1.06 0 00.212 1.17l.039.038a1.285 1.285 0 01-.417 2.098 1.285 1.285 0 01-1.402-.279l-.039-.038a1.06 1.06 0 00-1.17-.212 1.061 1.061 0 00-.643.97v.11a1.286 1.286 0 11-2.571 0v-.058a1.06 1.06 0 00-.695-.97 1.06 1.06 0 00-1.17.211l-.038.039a1.285 1.285 0 01-2.196-.91 1.286 1.286 0 01.377-.91l.038-.038a1.06 1.06 0 00.212-1.17 1.06 1.06 0 00-.97-.643h-.11a1.286 1.286 0 010-2.571h.058a1.06 1.06 0 00.971-.695 1.06 1.06 0 00-.212-1.17l-.039-.038a1.286 1.286 0 111.82-1.82l.038.04a1.06 1.06 0 001.17.211h.051a1.06 1.06 0 00.643-.97v-.11a1.286 1.286 0 012.572 0v.058a1.06 1.06 0 00.643.971 1.06 1.06 0 001.17-.212l.038-.039a1.285 1.285 0 111.82 1.82l-.04.038a1.06 1.06 0 00-.211 1.17v.051a1.061 1.061 0 00.97.643h.11a1.286 1.286 0 110 2.572h-.058a1.06 1.06 0 00-.97.643z"}})])
          )
        }
      }
    